import { isPlainObject, merge } from "lodash";
import { sensorStatus, magneticCompassStatus, flightInspectionTypes } from "@/views/tta/components/VTL/components/dictionary";

const state = {
    flightInspectionTypes: JSON.parse(JSON.stringify(flightInspectionTypes)),
    guidedLandingSet: false,// 引导降落是否已设置
    landingRouteSet: false,// 制式降落是否已设置
    pitchRollYaw: {
        pitch: 0,
        roll: 0,
        yaw: 0,
        airSpeed1: 0,
        airSpeed2: 0,
    },
    // 传感器
    sensorStatus: {
        ...sensorStatus
    },
    // 磁罗盘
    magneticCompassStatus: {
        ...magneticCompassStatus
    },
    // 摇杆
    rockerStatus: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    landingMode: -1,
    // 当前选中的航线编号
    selectRouteNum: undefined,
    rockerPopup1: false,
    rockerPopup2: false,
}

const mutations = {
    setState(state, { key, value }) {
        if (isPlainObject(state[key])) {
            state[key] = { ...state[key], ...value }
        } else {
            state[key] = value

        }
    },
}

const actions = {}

const getters = {
    passedInspection: (state) => {
        let pass = 0
        for (let index = 0; index < state.flightInspectionTypes.length; index++) {
            const { isNormal } = state.flightInspectionTypes[index];
            console.log(isNormal);
            if (isNormal) {
                pass += 1
            }
        }

        if (pass == state.flightInspectionTypes.length) {
            return true
        } else {
            return false
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
